<div class="lds-ripple">
	<div></div>
	<div></div>
</div>
